import { Box, Paper, Skeleton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { v4 } from 'uuid';

import { FC } from 'react';
import { CardGrid } from './disbursmentCard/cardGrid';

const useStyles = makeStyles((theme: any) => ({
  container: {
    padding: `${theme.spacing(2)}`,
    // Bound the fixed-width placeholder bars to their surface.
    overflow: 'hidden',
  },
  containerItems: {
    display: 'flex',
    gap: '10px',
    marginBottom: '10px',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    minWidth: 0,
    padding: theme.spacing(2),
    borderColor: theme.palette.border.line,
  },
  cardRow: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
}));

const CARD_SKELETON_IDS = ['first', 'second', 'third', 'fourth'] as const;

type SkeletonDisbursmentsProps = Readonly<{
  variant?: 'table' | 'card';
}>;

const SkeletonDisbursments: FC<SkeletonDisbursmentsProps> = ({ variant = 'table' }) => {
  const classes = useStyles();

  if (variant === 'card') {
    return (
      <CardGrid>
        {CARD_SKELETON_IDS.map((id) => (
          <Paper key={id} variant="outlined" className={classes.card}>
            <Skeleton variant="text" width="60%" height={28} />
            <Box className={classes.cardRow}>
              <Skeleton variant="text" width="35%" height={24} />
              <Skeleton variant="text" width="35%" height={24} />
            </Box>
            <Skeleton variant="rectangular" width="100%" height={40} />
          </Paper>
        ))}
      </CardGrid>
    );
  }

  return (
    <Box className={classes.container}>
      <Box className={classes.containerItems}>
        <Skeleton variant="text" width={150} height={40} />
        <Skeleton variant="text" width={300} height={40} />
        <Skeleton variant="text" width={150} height={40} />
        <Skeleton variant="text" width={150} height={40} />
        <Skeleton variant="text" width={150} height={40} />
        <Skeleton variant="text" width={300} height={40} />
        <Skeleton variant="text" width={150} height={40} />
        <Skeleton variant="text" width={150} height={40} />
      </Box>
      {Array.from({ length: 9 }).map((_) => (
        <Box key={v4()} className={classes.containerItems}>
          <Skeleton variant="rectangular" width={150} height={40} />
          <Skeleton variant="rectangular" width={300} height={40} />
          <Skeleton variant="rectangular" width={150} height={40} />
          <Skeleton variant="rectangular" width={150} height={40} />
          <Skeleton variant="rectangular" width={150} height={40} />
          <Skeleton variant="rectangular" width={300} height={40} />
          <Skeleton variant="rectangular" width={150} height={40} />
          <Skeleton variant="rectangular" width={150} height={40} />
        </Box>
      ))}
    </Box>
  );
};

export default SkeletonDisbursments;
